import { authRef, databaseRef, LocalPersistence } from 'config'
import * as moment from 'moment'

import { IParentData, IUserData, User } from 'data'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import * as mixpanel from 'mixpanel-browser'
import { Dispatch } from 'redux'

import { getIsPlusUser, setPlusUser } from 'services/plusUsers'
import { action } from '../../dispatchAction'
import { USER_ACTION_TYPES } from '../types'

export const login = (
  email: string,
  password: string,
  plusUserLib: any,
  successCallback: (data: any, isPlusUser?: boolean) => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async (dispatch: Dispatch, getState) => {
  dispatch(action(USER_ACTION_TYPES.login_begins))
  dispatch(action(USER_ACTION_TYPES.save_user_begins))

  await authRef.setPersistence(LocalPersistence)

  authRef
    .signInWithEmailAndPassword(email, password)
    .then((response: firebase.auth.UserCredential) => {
      if (response.user?.uid) {
        setPlusUser(response.user.uid, plusUserLib, false)
      }

      databaseRef
        .child(`users/${response.user!.uid}`)
        .once('value')
        .then(async (snapshot: firebase.database.DataSnapshot) => {
          const userData: IUserData = {
            ...snapshot.val(),
            userId: response.user?.uid
          }
          const parentData: IParentData = await (
            await databaseRef
              .child(`parents/${response.user!.uid}`)
              .once('value')
          ).val()

          window.localStorage.setItem('userId', response.user!.uid)

          const user: User | IUserData = parentData
            ? { ...parentData, ...userData }
            : userData

          // update display name of auth user
          if (!response.user?.displayName && userData.full_name) {
            console.log('user data: ', userData)
            await response.user?.updateProfile({
              displayName: userData.full_name
            })
          }

          // mixpanel.people.set({
          //   'Latest Login Time': moment().format('MMMM Do YYYY, h:mm:ss a')
          // })
          // // *should call user.identify after every `people.set`, check documentation for more details
          mixpanel.identify(user.userId)

          mixpanel.track('Logged in', { date: moment().unix() })
          // !end of mixpanel stuff

          dispatch(
            action(USER_ACTION_TYPES.login_success, {
              userData: user,
              // userAuth: {...response.user},
              userAuth: {
                uid: response.user?.uid,
                displayName: response.user?.displayName,
                email: response.user?.email,
                phoneNumber: response.user?.phoneNumber,
                photoURL: response.user?.photoURL,
                providerId: response.user?.providerData,
                emailVerified: response.user?.emailVerified,
                metadata: response.user?.metadata,
                isAnonymous: response.user?.isAnonymous,
                refreshToken: response.user?.refreshToken
              }
            })
          )

          dispatch(
            action(USER_ACTION_TYPES.save_user_success, {
              user: { ...userData }
            })
          )
          const isPlusUser = await getIsPlusUser(user.userId)
          successCallback(user, isPlusUser)
        })
        .catch(error => {
          const { code, message } = error
          dispatch(
            action(USER_ACTION_TYPES.login_error, {
              code,
              message
            })
          )

          errorCallback(message)
        })
    })
    .catch(error => {
      const { code, message } = error
      dispatch(
        action(USER_ACTION_TYPES.login_error, {
          code,
          message
        })
      )

      errorCallback(message)
    })
}



// WEBPACK FOOTER //
// ./src/store/user/actions/login.action.ts